import {
  INICIA_REMATRICULA,
  SALVA_REMATRICULA,
  SALVA_REMATRICULA_SUCESSO,
  LIMPAR_REMATRICULA,
  LISTA_ESCOLAS_REMATRICULA,
  LISTA_ESCOLAS_REMATRICULA_SUCESSO,
  LISTA_CURSOS_REMATRICULA,
  LISTA_CURSOS_REMATRICULA_SUCESSO,
  LISTA_SERIES_REMATRICULA,
  LISTA_SERIES_REMATRICULA_SUCESSO,
  LISTA_TURMAS_ORIGEM_REMATRICULA,
  LISTA_TURMAS_ORIGEM_REMATRICULA_SUCESSO,
  LISTA_TURMAS_DESTINO_REMATRICULA,
  LISTA_TURMAS_DESTINO_REMATRICULA_SUCESSO,
  LISTA_ANOS_DESTINO_REMATRICULA,
  LISTA_ANOS_DESTINO_REMATRICULA_SUCESSO,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_SHOW_SUCCESS_MESSAGE,
  NOVA_REMATRICULA,
  VERIFICA_SEQUENCIA_ENTURMACAO,
  VERIFICA_SEQUENCIA_ENTURMACAO_SUCESSO,
  LISTA_TURMAS_FILTRO_REMATRICULA,
  LISTA_TURMAS_FILTRO_REMATRICULA_SUCESSO,
  LISTA_REMATRICULA,
  LISTA_REMATRICULA_SUCESSO,
  DETALHE_REMATRICULA,
  DETALHE_REMATRICULA_SUCESSO,
  FECHAR_DETALHE_REMATRICULA
} from "constants/ActionTypes";

export const iniciaRematricula = () => ({ type: INICIA_REMATRICULA });

export const novaRematricula = () => ({ type: NOVA_REMATRICULA });

export const salvaRematricula = (dados) => ({ type: SALVA_REMATRICULA, payload: dados });
export const salvaRematriculaSucesso = (mensagem) => ({ type: SALVA_REMATRICULA_SUCESSO, payload: mensagem });

export const limparRematricula = () => ({ type: LIMPAR_REMATRICULA });

export const listaEscolasRematricula = () => ({ type: LISTA_ESCOLAS_REMATRICULA });
export const listaEscolasRematriculaSucesso = (escolas) => ({ type: LISTA_ESCOLAS_REMATRICULA_SUCESSO, payload: escolas });

export const listaCursosRematricula = (escolaId) => ({ type: LISTA_CURSOS_REMATRICULA, payload: escolaId });
export const listaCursosRematriculaSucesso = (cursos) => ({ type: LISTA_CURSOS_REMATRICULA_SUCESSO, payload: cursos });

export const listaSeriesRematricula = (cursoId) => ({ type: LISTA_SERIES_REMATRICULA, payload: cursoId });
export const listaSeriesRematriculaSucesso = (series) => ({ type: LISTA_SERIES_REMATRICULA_SUCESSO, payload: series });

export const listaTurmasOrigemRematricula = (params) => ({ type: LISTA_TURMAS_ORIGEM_REMATRICULA, payload: params });
export const listaTurmasOrigemRematriculaSucesso = (turmas) => ({ type: LISTA_TURMAS_ORIGEM_REMATRICULA_SUCESSO, payload: turmas });

export const listaAnosDestinoRematricula = (escolaId) => ({ type: LISTA_ANOS_DESTINO_REMATRICULA, payload: escolaId });
export const listaAnosDestinoRematriculaSucesso = (anos) => ({ type: LISTA_ANOS_DESTINO_REMATRICULA_SUCESSO, payload: anos });

export const verificaSequenciaEnturmacao = (params) => ({ type: VERIFICA_SEQUENCIA_ENTURMACAO, payload: params });
export const verificaSequenciaEnturmacaoSucesso = (sequencia) => ({ type: VERIFICA_SEQUENCIA_ENTURMACAO_SUCESSO, payload: sequencia });

export const listaTurmasFiltroRematricula = (escolaId) => ({ type: LISTA_TURMAS_FILTRO_REMATRICULA, payload: escolaId });
export const listaTurmasFiltroRematriculaSucesso = (turmas) => ({ type: LISTA_TURMAS_FILTRO_REMATRICULA_SUCESSO, payload: turmas });

export const listaTurmasDestinoRematricula = (params) => ({ type: LISTA_TURMAS_DESTINO_REMATRICULA, payload: params });
export const listaTurmasDestinoRematriculaSucesso = (turmas) => ({ type: LISTA_TURMAS_DESTINO_REMATRICULA_SUCESSO, payload: turmas });

export const listaRematricula = (filtros) => ({ type: LISTA_REMATRICULA, payload: filtros });
export const listaRematriculaSucesso = (lista) => ({ type: LISTA_REMATRICULA_SUCESSO, payload: lista });

export const detalheRematricula = (id) => ({ type: DETALHE_REMATRICULA, payload: id });
export const detalheRematriculaSucesso = (detalhe) => ({ type: DETALHE_REMATRICULA_SUCESSO, payload: detalhe });
export const fecharDetalheRematricula = () => ({ type: FECHAR_DETALHE_REMATRICULA });

export const limparFiltroRematricula = () => ({ type: LIMPAR_REMATRICULA }); // Reutilizando limpar ou criar um especifico

// UI Helpers
export const showLoader = () => ({ type: ON_SHOW_LOADER });
export const showAuthLoader = () => ({ type: ON_SHOW_LOADER });
export const exibirMensagemErro = (message) => ({ type: SHOW_MESSAGE, payload: message });
export const showAuthMessage = (message) => ({ type: SHOW_MESSAGE, payload: message });
export const hideMessage = () => ({ type: HIDE_MESSAGE });
export const showSuccessMessage = (message) => ({ type: ON_SHOW_SUCCESS_MESSAGE, payload: message });
